/**
 * Identifies TLF data and variant metadata paths belonging to the same editable transaction.
 *
 * @param path - JSON pointer from a unified history operation.
 * @returns Whether the operation affects the TLF view or its variant composition.
 */
export const isTlfEditablePath = (path: string): boolean =>
  path === "/tlfData" ||
  path.startsWith("/tlfData/") ||
  path === "/variant" ||
  path.startsWith("/variant/");
